/* eslint-disable react/no-access-state-in-setstate */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, FormControl, Panel, Row } from 'react-bootstrap';
import ShipmentWebAPIUtils from 'utils/ShipmentWebAPIUtils';
import ExceptionStore from 'stores/ExceptionStore';
import ShipmentsActionCreators from 'actions/ShipmentsActionCreators';
import ShipmentStore from 'stores/ShipmentStore';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PDFViewer from '../PDFViewer';
import { getDocumentsV2, getSignedUrl, } from '../../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../../stores/ToastStore';
class RequestChanges extends Component {
    constructor(props) {
        super(props);
        this.onTextChange = (event) => {
            this.setState({ request_text: event.target.value });
        };
        this.getShipment = (id) => {
            // This is for carriers.
            const isAdmin = false;
            ShipmentsActionCreators.getShipment(id, isAdmin);
        };
        this.shipmentChange = async () => {
            var _a, _b, _c;
            const { t } = this.props;
            const shipment = ShipmentStore.getShipment(this.state.id);
            const { data, errors: documentErrors } = await getDocumentsV2([shipment._id], 'delivery_order', {
                order: {
                    field: 'createdAt',
                    direction: 'desc',
                },
                limit: 1,
            });
            if (documentErrors) {
                showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                    error: documentErrors[0].message,
                }), 'error');
                return;
            }
            if (((_b = (_a = data === null || data === void 0 ? void 0 : data.getDocumentsV2) === null || _a === void 0 ? void 0 : _a.documents) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                const { data: signedUrlData, errors: signedUrlErrors } = await getSignedUrl(data.getDocumentsV2.documents[0].key);
                if (signedUrlErrors) {
                    showToast(t('GET_DOCUMENT_ERROR'), t('GET_DOCUMENT_FAILED_WITH_ERROR', {
                        error: signedUrlErrors[0].message,
                    }), 'error');
                    return;
                }
                if ((_c = signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.getSignedUrl) === null || _c === void 0 ? void 0 : _c.signedUrl) {
                    const signedUrl = signedUrlData === null || signedUrlData === void 0 ? void 0 : signedUrlData.getSignedUrl.signedUrl;
                    this.setState({ shipment, signedUrl });
                }
            }
            this.setState({ shipment });
        };
        this.exceptionChange = () => {
            // If there was an error creating the exception, don't do anything.
            // If it succeeded, redirect to the shipments page.
            if (!ExceptionStore.getCreationError()) {
                // Allow time for the success toast to display.
                setTimeout(() => {
                    window.location.href = '/shipments';
                }, 3000);
            }
        };
        this.handleSubmit = async () => {
            const { request_text, shipment: { _id }, } = this.state;
            const statusUpdate = {
                message: request_text,
                status: 'change_request',
            };
            const result = await ShipmentWebAPIUtils.updateChangeException(_id, statusUpdate);
            if (result) {
                setTimeout(() => {
                    window.location.href = '/shipments';
                }, 3000);
            }
        };
        this.state = {
            id: props.match.params.id,
            shipment: {},
            signedUrl: null,
        };
    }
    componentDidMount() {
        ShipmentStore.addChangeListener(this.shipmentChange.bind(this));
        ExceptionStore.addChangeListener(this.exceptionChange);
        this.getShipment(this.state.id);
    }
    componentWillUnmount() {
        ShipmentStore.removeChangeListener(this.shipmentChange.bind(this));
        ExceptionStore.removeChangeListener(this.exceptionChange);
    }
    renderChangeRequest(shipment) {
        return (React.createElement("div", null,
            React.createElement(Row, null,
                React.createElement("h2", null, this.props.t('SUBMIT_DELIVERY_CHANGE_REQUEST', {
                    shipmentId: shipment.shipment_id,
                }))),
            React.createElement(Row, { className: "py-8" },
                React.createElement(FormControl, { componentClass: "textarea", rows: 5, placeholder: this.props.t('ENTER_REQUESTED_CHANGES'), value: this.state.request_text, onChange: this.onTextChange })),
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(Button, { className: "pull-right", bsStyle: "success", style: { marginTop: 10 + 'px' }, onClick: this.handleSubmit }, titleize(this.props.t('SUBMIT')))))));
    }
    renderDeliveryOrderPdf() {
        if (this.state.signedUrl) {
            return (React.createElement(Row, null,
                React.createElement(PDFViewer, { file: this.state.signedUrl })));
        }
        return (React.createElement(Row, null,
            React.createElement("span", null, this.props.t('WAITING_FOR_PDF'))));
    }
    render() {
        const shipment = this.state.shipment;
        return (shipment && (React.createElement(Panel, null,
            React.createElement("div", null,
                React.createElement(Col, { xs: 6 }, this.renderChangeRequest(shipment)),
                React.createElement(Col, { xs: 6 }, this.renderDeliveryOrderPdf())))));
    }
}
RequestChanges.propTypes = {
    match: PropTypes.object.isRequired,
};
export default withTranslation()(RequestChanges);
